import axios from 'axios'
import {http} from "../../config/Constantes";

export default class CRUDService {

    constructor(name) {
        this.serviceName = name;
    }

    findById(id) {
        return http.get("/"+this.serviceName+"/"+id)
    }

    list() {
        return http.get("/"+this.serviceName)
    }

    edit(id, item) {
        return http.put("/"+this.serviceName+"/"+id, item)
    }

    save(item) {
        return http.post("/"+this.serviceName, item)
    }

    delete(id) {
        return http.delete("/"+this.serviceName+"/"+id)
    }
}